import { render, staticRenderFns } from "./DesafiosIcon.vue?vue&type=template&id=46e2038a&scoped=true&"
var script = {}
import style0 from "./DesafiosIcon.vue?vue&type=style&index=0&id=46e2038a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2038a",
  null
  
)

export default component.exports